/* Moments Etched v15.4.7.13 — customer-facing preview context consistency */
(() => {
  const INTERNAL_NECK_PLACEMENT = 'Custom Neck Label';

  const getNeckMode = (root) => String(
    root?.dataset?.meNeckLabelMode ||
    root?.querySelector?.('[data-me-neck-label-choice]:checked')?.value ||
    'original'
  );

  const neckDisplayLabel = (root) => {
    const mode = getNeckMode(root);
    if (mode === 'me-branding') return 'Moments Etched Label';
    if (mode === 'custom') return 'Your Brand Label';
    return 'Neck Label';
  };

  const activeInternalPlacement = (root) => String(
    root?.querySelector?.('[data-me-preview-placement-label]')?.textContent || ''
  ).trim();

  const syncNeckContext = (root) => {
    if (!root) return;

    const internalPlacement = activeInternalPlacement(root);
    const isNeck = internalPlacement === INTERNAL_NECK_PLACEMENT;
    const label = neckDisplayLabel(root);

    /* Keep the underlying text/internal key untouched because existing preview,
       calibration and selected-placement logic reads it. The visible label is
       supplied through a data attribute and CSS pseudo-element instead. */
    const internalLabel = root.querySelector('[data-me-preview-placement-label]');
    if (internalLabel) {
      if (isNeck) {
        internalLabel.dataset.meCustomerPlacementLabel = label;
        internalLabel.setAttribute('aria-label', label);
      } else {
        delete internalLabel.dataset.meCustomerPlacementLabel;
        internalLabel.removeAttribute('aria-label');
      }
    }

    root.querySelectorAll('.me-studio-preview-tabs [data-me-preview-placement="Custom Neck Label"]').forEach((button) => {
      if (button.textContent !== label) button.textContent = label;
      button.setAttribute('aria-label', `Preview ${label}`);
    });

    if (isNeck) {
      root.querySelectorAll('[data-me-studio-preview-label], .me-designer__preview-toolbar h3, [data-me-designer-active-location]').forEach((node) => {
        if (node && !node.matches('[data-me-preview-placement-label]')) node.textContent = label;
      });

      const viewStatus = root.querySelector('[data-me-designer-view-status]');
      if (viewStatus) {
        viewStatus.textContent = 'Inside neck view';
        viewStatus.setAttribute('aria-label', 'Inside neck view');
        viewStatus.dataset.meCustomerViewStatus = 'inside-neck';
      }
    } else {
      const viewStatus = root.querySelector('[data-me-designer-view-status]');
      if (viewStatus?.dataset?.meCustomerViewStatus === 'inside-neck') {
        delete viewStatus.dataset.meCustomerViewStatus;
        viewStatus.removeAttribute('aria-label');
      }
    }
  };

  const syncAll = () => document.querySelectorAll('[data-me-designer]').forEach(syncNeckContext);

  const bindRoot = (root) => {
    if (!root || root.dataset.meV154713Bound === 'true') {
      syncNeckContext(root);
      return;
    }
    root.dataset.meV154713Bound = 'true';

    const internalLabel = root.querySelector('[data-me-preview-placement-label]');
    if (internalLabel) {
      new MutationObserver(() => requestAnimationFrame(() => syncNeckContext(root)))
        .observe(internalLabel, { childList: true, characterData: true, subtree: true });
    }

    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => ['data-me-studio-stage', 'data-me-neck-label-mode'].includes(mutation.attributeName))) {
        requestAnimationFrame(() => syncNeckContext(root));
      }
    }).observe(root, { attributes: true, attributeFilter: ['data-me-studio-stage', 'data-me-neck-label-mode'] });

    root.addEventListener('change', (event) => {
      if (event.target?.matches?.('[data-me-neck-label-choice]')) requestAnimationFrame(() => syncNeckContext(root));
    });

    syncNeckContext(root);
  };

  const init = () => document.querySelectorAll('[data-me-designer]').forEach(bindRoot);

  window.addEventListener('me:preview-placement', () => requestAnimationFrame(() => requestAnimationFrame(syncAll)));
  window.addEventListener('me:neck-label-updated', () => requestAnimationFrame(syncAll));
  window.addEventListener('me:placements-updated', () => requestAnimationFrame(syncAll));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
